<template>
    <div class="cases-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div class="header-bg" style="background-image: url('https://picsum.photos/id/599/1920/400');"></div>
            <div class="header-content">
                <h1>成功案例</h1>
                <p>我们完成的新能源项目案例展示</p>
                <i style="color: #b77777">仅展示部分，不代表全部案例</i>
            </div>
        </div>

        <!-- 案例列表 -->
        <section class="cases-list">
            <div class="container">
                <div class="cases-grid">
                    <div class="case-card" v-for="caseItem in cases" :key="caseItem.id" @click="$router.push(`/cases/${caseItem.id}`)">
                        <div class="case-img">
                            <img :src="caseItem.coverImage || `https://picsum.photos/id/${100+caseItem.id}/400/300`" :alt="caseItem.title">
                        </div>
                        <div class="case-info">
                            <h3>{{ caseItem.title }}</h3>
                            <p class="case-client"><i class="fa fa-user"></i> {{ caseItem.client }}</p>
                            <p class="case-location"><i class="fa fa-map-marker"></i> {{ caseItem.projectLocation }}</p>
                            <p class="case-date"><i class="fa fa-calendar"></i> {{ caseItem.completionTime }}</p>
                        </div>
                    </div>
                </div>

                <!-- 分页 -->
                <div class="pagination" v-if="total > 0">
                    <button @click="changePage(currentPage - 1)" :disabled="currentPage <= 1">上一页</button>
                    <span>{{ currentPage }} / {{ totalPages }}</span>
                    <button @click="changePage(currentPage + 1)" :disabled="currentPage >= totalPages">下一页</button>
                </div>
            </div>

        </section>
    </div>
</template>

<script>
import { caseApi } from '@/api'

export default {
    name: 'CasesPage',
    data() {
        return {
            cases: [],
            total: 0,
            pageSize: 6,
            currentPage: 1,
            totalPages: 0
        }
    },
    mounted() {
        this.getCases()
        this.getCaseCount()
    },
    methods: {
        // 获取案例列表
        getCases() {
            const pageNum = (this.currentPage - 1) * this.pageSize
            caseApi.getCasesByPage(pageNum, this.pageSize).then(res => {
                this.cases = res.data
            }).catch(err => {
                console.error('获取案例列表失败:', err)
            })
        },

        // 获取案例总数
        getCaseCount() {
            caseApi.getCaseCount().then(res => {
                this.total = res.data
                this.totalPages = Math.ceil(this.total / this.pageSize)
            }).catch(err => {
                console.error('获取案例总数失败:', err)
            })
        },

        // 切换页码
        changePage(page) {
            if (page < 1 || page > this.totalPages) return
            this.currentPage = page
            this.getCases()
            // 滚动到顶部
            window.scrollTo(0, 0)
        }
    }
}
</script>

<style scoped>
/* 页面头部样式 */
.page-header {
    position: relative;
    height: 400px;
    overflow: hidden;
}

.header-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    filter: brightness(0.6);
}

.header-content {
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
}

.header-content h1 {
    font-size: 3rem;
    margin-bottom: 15px;
}

.header-content p {
    font-size: 1.2rem;
}

/* 案例列表样式 */
.cases-list {
    padding: 80px 0;
    background-color: #f9f9f9;
}

.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.cases-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 30px;
    margin-bottom: 40px;
}

.case-card {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: all 0.3s;
    cursor: pointer;
}

.case-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.case-img {
    height: 200px;
    overflow: hidden;
}

.case-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s;
}

.case-card:hover .case-img img {
    transform: scale(1.05);
}

.case-info {
    padding: 20px;
}

.case-info h3 {
    font-size: 1.2rem;
    color: #2c3e50;
    margin-bottom: 15px;
}

.case-client,
.case-location,
.case-date {
    font-size: 0.9rem;
    color: #7f8c8d;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
}

.case-client i,
.case-location i,
.case-date i {
    margin-right: 8px;
    color: #165DFF;
}

/* 分页样式 */
.pagination {
    text-align: center;
    margin-top: 30px;
}

.pagination button {
    padding: 8px 15px;
    margin: 0 10px;
    background-color: #165DFF;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.pagination button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.pagination span {
    color: #2c3e50;
    font-size: 1rem;
}

/* 响应式样式 */
@media (max-width: 768px) {
    .page-header {
        height: 300px;
    }

    .header-content h1 {
        font-size: 2.2rem;
    }

    .cases-list {
        padding: 50px 0;
    }
}
</style>